/**
 * The function "isExact" checks if two input values are exactly equal in JavaScript.
 * @param data1 - The first parameter of the function `isExact`. It is a variable that holds some data
 * that needs to be compared with another data.
 * @param data2 - The parameter `data2` is the second piece of data that is being compared for exact
 * equality with `data1` in the `isExact` function.
 */
export const isExact = (data1, data2) => data1 === data2;

/**
 * The function checks if two data inputs are not equal.
 * @param data1 - The first parameter of the `isNotEqual` function, which is a variable or value that
 * will be compared to the second parameter.
 * @param data2 - The parameter `data2` is the second piece of data that is being compared for
 * inequality in the `isNotEqual` function. It is the value that is being compared to `data1` to
 * determine if they are not equal.
 */
export const isNotEqual = (data1, data2) => data1 !== data2;

/**
 * The function checks if the first input is greater than the second input.
 * @param data1 - The first data value to compare.
 * @param data2 - The `data2` parameter is the second value that you want to compare.
 */
export const isGreaterThan = (data1, data2) => data1 > data2;

/**
 * The function `isLessThan` checks if `data1` is less than `data2`.
 * @param data1 - The first data value to compare.
 * @param data2 - The `data2` parameter is the second data value that you want to compare.
 */
export const isLessThan = (data1, data2) => data1 < data2;
